/**
 * Reports Service Types
 *
 * Zod schemas for report service commands used in workflow validation.
 */

import { z } from 'zod/v4'
import { WorkflowNodeBaseSchema } from '../../resources/types'
import { GenerateReportInputSchema, DefineReportInputSchema } from './schemas'

export const ReportsCommandSchema = z.enum(['report.generate', 'report.define'])

const ReportGenerateCommandSchema = WorkflowNodeBaseSchema.extend({
  service: z.object({
    name: z.literal('skedyul/reports'),
    cmd: z.literal('report.generate'),
  }),
  inputs: GenerateReportInputSchema,
})

const ReportDefineCommandSchema = WorkflowNodeBaseSchema.extend({
  service: z.object({
    name: z.literal('skedyul/reports'),
    cmd: z.literal('report.define'),
  }),
  inputs: DefineReportInputSchema,
})

export const ReportsServiceSchema = z.union([
  ReportGenerateCommandSchema,
  ReportDefineCommandSchema,
])

export type ReportsCommand = z.infer<typeof ReportsCommandSchema>
export type ReportsService = z.infer<typeof ReportsServiceSchema>
